import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client'; // Importa createRoot de react-dom/client
import App from './App';

// Utilize createRoot para renderizar seu aplicativo
createRoot(document.getElementById('root')).render(<App />);

  <React.StrictMode>
    <App />
  </React.StrictMode>


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
